import React, { useEffect, useState } from 'react'

import {
    Typography, Paper, Divider, Stack, Grid, useMediaQuery, Card, Button,
} from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

import { Box } from '@mui/system';


import Menu from '../components/Menu';
import BottomMenu from '../components/BottomMenu';

import CheckIcon from '@mui/icons-material/CheckCircleOutline';
import WrongIcon from '@mui/icons-material/DangerousOutlined';

import { useDispatch, useSelector } from 'react-redux';
import { getNotifications } from '../redux/actions/userAction';
import { getBooks } from '../redux/actions/bookAction';
import moment from 'moment';

export default function Notifications() {
    const matches = useMediaQuery('(max-width:1150px)');
    const user = useSelector((state => state.user))
    const book = useSelector((state => state.book))

    const [page, setPage] = useState(5)
    const handlePage = (e) => {
        e.preventDefault();
        var num = page + 2;
        setPage(num)
    }
    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            },

        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        linkTexts: {
            textTransform: "none",
            color: (theme) => theme.palette.text.primary,
            fontWeight: "bold",
            fontSize: 18,
            "&: hover": {
                color: (theme) => theme.palette.primary.main,
                backgroundColor: "transparent"
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        cardDashboard: {
            borderRadius: 0,
            boxShadow: 0,
            minHeight: 90,
            opacity: 0.9
        },
        actionButton: {
            margin: 0,
            padding: 1,
            height: 23,
            backgroundColor: "#B9E291",
            boxShadow: 0,
            borderRadius: 0,
            fontSize: 12,
        },
        scrollableDiv: {
            maxHeight: "100vh",
            '@media only screen and (min-width: 1700px)': {
                height: 700
            },
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            overflow: 'auto',
            //for other browsers 
            scrollbarWidth: "none"
        },
        sideDiv: {
            position: "sticky",
            height: 500

        },
    }
    const dispatch = useDispatch()
    useEffect(() => {
        if (!book.bookEmpty && book.books.length <= 0) dispatch(getBooks());
        if (!user.notificationEmpty && user.notifications.length <= 0) dispatch(getNotifications());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const notifications = user.notifications

    const checkBookName = (bookID) => {
        var bookObject = {
            bookCover: "",
            bookTitle: ""
        }
        for (var x = 0; x < book.books.length; x++) {
            if (book.books[x].bookID === bookID) {
                bookObject = {
                    bookCover: book.books[x].bookCover,
                    bookTitle: book.books[x].bookTitle
                }
            }
        }
        return bookObject
    }

    var currentDate = moment().toISOString();

    const checkLate = (returnDate) => {
        return (moment(currentDate).diff(returnDate, 'days') < 7)
    }

    return (
        <Box>
            <SEO title="My Books - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... Services offered" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Grid container columns={12} spacing={1}>
                        {!matches && <Grid item xs={12} md={3} sx={{ padding: 3 }}>
                            <Menu />
                        </Grid>}
                        <Grid item xs={12} md={matches ? 12 : 9}>
                            <Box sx={style.scrollableDiv}>
                                <Stack direction="column" sx={{ marginBottom: 2 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: "#280707" }}>Notifications</Typography>
                                    <Typography variant="subtitle2" sx={{ fontStyle: 'italic', color: "#280707" }}>View your pending notifications here.</Typography>
                                </Stack>
                                <Divider sx={{ marginBottom: 2 }} />
                                <Stack direction="column">
                                    {Array.from(notifications).map((_, index) => (
                                        index < page &&
                                        <Grid key={index}>
                                            <Card elevation={0} sx={{ padding: 1 }} >
                                                <Stack direction='row' spacing={1} alignItems="center">
                                                    {notifications[index].notifStatus.toLowerCase() === "accepted" ?
                                                        <CheckIcon sx={{ fontSize: 50, color: (theme) => theme.palette.success.light, opacity: 0.9 }} /> :
                                                        <WrongIcon sx={{ fontSize: 50, color: (theme) => theme.palette.error.light, opacity: 0.9 }} />}
                                                    <Stack direction="column">
                                                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                                            {notifications[index].notifStatus}: {checkBookName(notifications[index].bookID).bookTitle}
                                                        </Typography>
                                                        <Typography variant="subtitle1"
                                                            sx={{
                                                                fontSize: matches ? 12 : 16,
                                                                opacity: 0.7
                                                            }}>
                                                            {notifications[index].notifContent}
                                                        </Typography>
                                                        <Typography variant="subtitle2">

                                                            {checkLate(notifications[index].notifTime) ?
                                                                moment(notifications[index].notifTime).fromNow() :
                                                                moment(notifications[index].notifTime).format('MMMM D, YYYY')}
                                                        </Typography>
                                                    </Stack>
                                                </Stack>
                                            </Card>
                                            <Divider sx={{ marginTop: 1 }} />
                                        </Grid>
                                    ))}
                                </Stack>
                                <Button
                                    onClick={handlePage}
                                    disableRipple
                                    color="primary"
                                    sx={{
                                        textAlign: "center",
                                        "&:hover": {
                                            cursor: "pointer"
                                        }
                                    }}
                                    fullWidth>
                                    See More...
                                </Button>
                                <Box sx={{ height: 100 }} />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>

            <Box sx={style.footerStyle}>
                {matches ?
                    <BottomMenu />
                    :
                    <Footer />}
            </Box>

        </Box>
    )
}
